// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_EmitInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Staff emit of a setup-fee charge.
 *
 * Staff select a MARKET RECORD (setup_price_default_id), filtered by the
 * franchise's country — that record carries gateway, currency, price and the
 * installment cap, so none of them is a client field.
 *
 * History (2026-08-20): amount_cents was a client field, which made the market
 * price a mere suggestion (the endpoint minted whatever was posted) and let the
 * form render a BRL amount for a franchise the backend would charge in CLP.
 * Dropping it left provider_code, which forced the backend to re-derive the row
 * as (country → currency, provider) while the form resolved it as
 * (country, provider) — two lookups for one question, free to disagree. The
 * record id is the single answer.
 */
import { registerContract } from './validate'

export interface SetupFee_EmitInput {
franquia_id: number
setup_price_default_id: number
request_id: string
installments?: number
}

registerContract('SetupFee_EmitInput', {
  franquia_id:            { type: 'number',  required: true },
  setup_price_default_id: { type: 'number',  required: true },
  request_id:             { type: 'string',  required: true },
  installments:           { type: 'number',  required: false },
})
